import { Dropdown, IconButton } from 'rsuite';
import iconEllipsis from '../../../../../../assets/icons/icon_ellipsis-v.svg';
import styles from './OptionsDropdown.module.scss';

type OptionsDropdownProps = {
  id: string;
  data: { key: string; label: string }[];
  onClick: (key: string) => void;
};

export const OptionsDropdown = ({ id, data, onClick }: OptionsDropdownProps) => {
  return (
    <Dropdown
      id={id}
      placement="bottomEnd"
      renderTitle={() => <IconButton className={styles['options-btn']} appearance="subtle" icon={<img alt="Mais opções" src={iconEllipsis} />} />}
    >
      {data.map(option => (
        <Dropdown.Item key={option.key} onClick={() => onClick(option.key)}>
          {option.label}
        </Dropdown.Item>
      ))}
    </Dropdown>
  );
};
